import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useIsFilterFromCustomView } from 'framework-listing-lib/hooks/useListingLibFilters';
import useHandleQueryParams from 'framework-listing-lib/internal/deepLink/hooks/useHandleQueryParams';
import { useCurrentUIMode, useIsFoldersMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import { Metrics } from 'framework-listing-lib/internal/metrics';
import { useListingLibData } from 'framework-listing-lib/internal/providers/DataProvider';
import { useHasViews, useOnViewIdChange, useViewPropsCurrentViewId } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import { getViewId } from 'framework-listing-lib/internal/ViewTabs/utils/views';
import { useCurrentViewContext } from 'framework-listing-lib/internal/ViewTabs/providers/CurrentViewProvider';
import { DEFAULT_VIEW_ID_TO_ID_LABEL } from 'framework-listing-lib/internal/ViewTabs/constants/views';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewsContext = /*#__PURE__*/createContext(undefined);
export default function ViewsProvider(t0) {
  "use memo";

  const $ = _c(40);
  const {
    children,
    onChangeUIMode
  } = t0;
  const currentUIMode = useCurrentUIMode();
  const isFoldersMode = useIsFoldersMode();
  const urlParams = useHandleQueryParams();
  const hasViews = useHasViews();
  const isFilterFromCustomView = useIsFilterFromCustomView();
  const onViewIdChange = useOnViewIdChange();
  const currentViewIdProp = useViewPropsCurrentViewId();
  const {
    currentView,
    loading: loadingCurrentView
  } = useCurrentViewContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [columns, setColumns] = useState(t1);
  const [numberOfFrozenColumns, setNumberOfFrozenColumns] = useState(undefined);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [cardProperties, setCardProperties] = useState(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [quickFilterPropertyNames, setQuickFilterPropertyNames] = useState(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      changedCardProperties: false,
      changedColumns: false,
      changedQuickFilterPropertyNames: false,
      changedSort: false,
      changedUIMode: false,
      mLangGroup: {
        changed: false,
        showAll: false
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [viewUpdateState, setViewUpdateState] = useState(t4);
  const {
    loading: loadingListingLibData
  } = useListingLibData();
  const hasChangedFilters = hasViews && !isFilterFromCustomView;
  const t5 = hasChangedFilters || viewUpdateState.changedColumns || viewUpdateState.changedSort || viewUpdateState.changedUIMode || viewUpdateState.mLangGroup.changed || viewUpdateState.changedCardProperties || viewUpdateState.changedQuickFilterPropertyNames;
  const t6 = !isFoldersMode && hasViews && (loadingCurrentView || columns.length === 0 && currentView !== undefined);
  let t7;
  if ($[4] !== cardProperties || $[5] !== columns || $[6] !== currentView || $[7] !== numberOfFrozenColumns || $[8] !== quickFilterPropertyNames || $[9] !== t5 || $[10] !== t6 || $[11] !== viewUpdateState) {
    t7 = {
      cardProperties,
      currentView,
      columns,
      isCurrentViewModified: t5,
      isLoading: t6,
      numberOfFrozenColumns,
      quickFilterPropertyNames,
      setCardProperties,
      setColumns,
      setNumberOfFrozenColumns,
      setQuickFilterPropertyNames,
      setViewUpdateState,
      viewUpdateState
    };
    $[4] = cardProperties;
    $[5] = columns;
    $[6] = currentView;
    $[7] = numberOfFrozenColumns;
    $[8] = quickFilterPropertyNames;
    $[9] = t5;
    $[10] = t6;
    $[11] = viewUpdateState;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const value = t7;
  const [prevViewId, setPrevViewId] = useState(undefined);
  if (currentView && prevViewId !== currentView.id && !loadingCurrentView && !loadingListingLibData && hasViews) {
    var _currentView$quickFil, _currentView$quickFil2;
    setPrevViewId(currentView.id);
    setColumns(currentView.columns.map(_temp));
    setQuickFilterPropertyNames((_currentView$quickFil = (_currentView$quickFil2 = currentView.quickFilterProperties) === null || _currentView$quickFil2 === void 0 ? void 0 : _currentView$quickFil2.map(_temp2)) !== null && _currentView$quickFil !== void 0 ? _currentView$quickFil : []);
    setNumberOfFrozenColumns(currentView.state.numberOfFrozenColumns || 0);
    setCardProperties(currentView.state.cardProperties || []);
    setViewUpdateState({
      changedCardProperties: false,
      changedColumns: false,
      changedQuickFilterPropertyNames: false,
      changedSort: false,
      changedUIMode: Boolean(currentView.state.uiMode && currentUIMode !== currentView.state.uiMode),
      mLangGroup: {
        changed: false,
        showAll: currentView.state && currentView.state.mLangGroup ? currentView.state.mLangGroup.showAll : false
      }
    });
  }
  const [prevViewIdForEffect, setPrevViewIdForEffect] = useState(undefined);
  let t8;
  let t9;
  if ($[13] !== currentUIMode || $[14] !== currentView || $[15] !== hasViews || $[16] !== loadingCurrentView || $[17] !== loadingListingLibData || $[18] !== onChangeUIMode || $[19] !== prevViewIdForEffect) {
    t8 = () => {
      if (!hasViews || loadingListingLibData || loadingCurrentView || !currentView) {
        return;
      }
      if (currentView.id === prevViewIdForEffect) {
        return;
      }
      setPrevViewIdForEffect(currentView.id);
      if (currentView.state.uiMode && currentUIMode !== currentView.state.uiMode && onChangeUIMode) {
        onChangeUIMode(currentView.state.uiMode);
      }
    };
    t9 = [currentUIMode, currentView, hasViews, loadingCurrentView, loadingListingLibData, onChangeUIMode, prevViewIdForEffect];
    $[13] = currentUIMode;
    $[14] = currentView;
    $[15] = hasViews;
    $[16] = loadingCurrentView;
    $[17] = loadingListingLibData;
    $[18] = onChangeUIMode;
    $[19] = prevViewIdForEffect;
    $[20] = t8;
    $[21] = t9;
  } else {
    t8 = $[20];
    t9 = $[21];
  }
  useEffect(t8, t9);
  const [hasUsedQueryParams, setHasUsedQueryParams] = useState(false);
  let t10;
  let t11;
  if ($[22] !== hasUsedQueryParams || $[23] !== loadingCurrentView || $[24] !== loadingListingLibData || $[25] !== urlParams) {
    t10 = () => {
      if (loadingListingLibData || loadingCurrentView || !urlParams || hasUsedQueryParams) {
        return;
      }
      if (!urlParams.columns.length) {
        return;
      }
      setColumns(urlParams.columns);
      setViewUpdateState(_temp3);
      setHasUsedQueryParams(true);
    };
    t11 = [hasUsedQueryParams, loadingListingLibData, loadingCurrentView, urlParams];
    $[22] = hasUsedQueryParams;
    $[23] = loadingCurrentView;
    $[24] = loadingListingLibData;
    $[25] = urlParams;
    $[26] = t10;
    $[27] = t11;
  } else {
    t10 = $[26];
    t11 = $[27];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[28] !== currentView || $[29] !== currentViewIdProp || $[30] !== hasViews || $[31] !== isFoldersMode || $[32] !== loadingCurrentView || $[33] !== loadingListingLibData || $[34] !== onViewIdChange) {
    t12 = () => {
      if (isFoldersMode || loadingListingLibData || loadingCurrentView || !currentView || !hasViews) {
        return;
      }
      const isSameViewId = currentViewIdProp === currentView.id;
      const isSameViewIdLabel = currentView.idLabel && currentViewIdProp === currentView.idLabel;
      const matchesLegacyDefaultViewId = Boolean(currentViewIdProp && DEFAULT_VIEW_ID_TO_ID_LABEL[currentViewIdProp] && (DEFAULT_VIEW_ID_TO_ID_LABEL[currentViewIdProp] === currentView.id || DEFAULT_VIEW_ID_TO_ID_LABEL[currentViewIdProp] === currentView.idLabel));
      const shouldRedirect = !isSameViewId && !isSameViewIdLabel && !matchesLegacyDefaultViewId;
      if (shouldRedirect) {
        Metrics.counter("ignore-quick-fetch-cache").increment();
        onViewIdChange(getViewId(currentView), {
          redirect: true
        });
      }
    };
    t13 = [currentView, currentViewIdProp, hasViews, isFoldersMode, loadingListingLibData, loadingCurrentView, onViewIdChange];
    $[28] = currentView;
    $[29] = currentViewIdProp;
    $[30] = hasViews;
    $[31] = isFoldersMode;
    $[32] = loadingCurrentView;
    $[33] = loadingListingLibData;
    $[34] = onViewIdChange;
    $[35] = t12;
    $[36] = t13;
  } else {
    t12 = $[35];
    t13 = $[36];
  }
  useEffect(t12, t13);
  let t14;
  if ($[37] !== children || $[38] !== value) {
    t14 = /*#__PURE__*/_jsx(ViewsContext.Provider, {
      value: value,
      children: children
    });
    $[37] = children;
    $[38] = value;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
}
function _temp3(prev) {
  return Object.assign({}, prev, {
    changedColumns: true
  });
}
function _temp2(t0) {
  const {
    name
  } = t0;
  return name;
}
function _temp(column) {
  return column.name;
}
export function useViews() {
  "use memo";

  const context = useContext(ViewsContext);
  if (context === undefined) {
    throw new Error("useViews must be used within a ViewsProvider");
  }
  return context;
}